import { FAKE_DLR as PREFIX, DEFAULT_PER_PAGE_MEDIUM } from "const";
import { FAKE_DLR_SET_LIST, FAKE_DLR_SET_LOADING, FAKE_DLR_SUPPLIER_SET_LIST } from "actions/actionTypes";

const initialState = {
    list: [],
    supplierList: [],
    loading: true,
    page: 1,
    count: 0,
    per_page: DEFAULT_PER_PAGE_MEDIUM
};

const handlers = {
    [FAKE_DLR_SET_LOADING]: (state, { payload }) => ({ ...state, loading: payload }),
    [FAKE_DLR_SET_LIST]: (state, { payload: { list, page, perPage, count } }) => ({
        ...state,
        list,
        page,
        per_page: perPage,
        count,
        loading: false,
    }),
    [FAKE_DLR_SUPPLIER_SET_LIST]: (state, { payload: { list } }) => ({
        ...state,
        supplierList: list
    }),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
};